<template>
  <div :class="['report-runtime', parseInt(report.reportType) === 5 && 'custom-page-list',  referenceObjParam && referenceObjParam.type === 'rc-report' && 'rc-report-width', $route.path.includes('report-design-list') && 'report-design-preview', `${report.id}_report`]">
    <group-report-tabs  ref="reportTabs"  v-if="report.id&&report.groupReportData&&report.groupReportData.length>1" :groupReports='report.groupReportData' :formRuntimeDialog="formRuntimeDialog" @closeReportDialog="closeReportDialog"/>
    <report-component v-on="$listeners" ref="report" v-if="report.id&&(report.groupReportData&&report.groupReportData.length<=1||report.groupReportData===null)" :report='report' :formRuntimeDialog="formRuntimeDialog" @closeReportDialog="closeReportDialog" :formDefinition="formDefinition" :referenceObjParam="referenceObjParam"/>
    <public-dialog v-if="publicDialog.visible" :data="publicDialog"></public-dialog>
    <dialog-form-runtime :formRuntimeDialog="formRuntimeDialog" @goSearch="goSearch"></dialog-form-runtime>
    <!--定制页面的标签页弹窗,根据path动态渲染component-->
    <dialog-custom :customDialog="customDialog" @popUpSearch="popUpSearch"></dialog-custom>
  </div>
</template>

<script>
import sdk from 'redcatSdk'
import _ from 'lodash'
import ReportComponent from './report-component.vue'
import CodeService, { EventBus } from '@/store/form-runtime/codeService'
import GroupReportTabs from './group-report-tabs.vue'
import { UUID } from '@/plugins/common'
export default {
  name: 'ReportRuntime',
  provide () {
    return {
      eventBus: this.eventBus,
      redcatApp: this.getRedcatApp,
      loadScript: this.loadScript,
      reportVm: this
    }
  },
  components: {
    DialogFormRuntime: () => import('@/components/shared/dialog-form-runtime.vue'),
    DialogCustom: () => {
      return Promise.resolve(sdk.components.DialogCustom)
    },
    ReportComponent,
    PublicDialog: () => {
      return Promise.resolve(sdk.components.PublicDialog)
    },
    GroupReportTabs
  },
  props: ['id', 'referenceObjParam'],
  data () {
    return {
      eventBus: new EventBus(),
      report: {},
      show: true,
      publicDialog: {
        visible: false,
        title: 'title',
        width: '30%',
        buttonClick: null,
        buttons: [
          {name: '取 消', type: 'cancel'},
          {name: '确 定', type: 'confirm'}
        ],
        // 是否可以通过点击 modal 关闭弹窗
        closeWithClick: true,
        // 是否可以通过 esc键 关闭弹窗
        closeWithEsc: true
      },
      formRuntimeDialog: {
        visible: false,
        id: '',
        width: '',
        dataId: '',
        formValidates: [],
        type: 'form',
        interactions: [],
        // 对比字段
        compareField: '',
        // 透传字段
        passFieldList: [],
        openType: ''
      },
      customDialog: {
        visible: false,
        path: '',
        dataId: '',
        title: '',
        id: ''
      },
      formDefinition: {},
      redcatApp: {}
    }
  },
  async created () {
    const reportId = this.id
    if (reportId) {
      this.report = await this.loadReport(reportId)
      this.report.background = this.report.background ? JSON.parse(this.report.background) : {src: '', name: ''}
    } else {
      throw new Error('报表不存在.')
    }
    // 如果没有 reportType的话默认值为 0
    if (this.report.reportType === null || this.report.reportType === undefined) {
      this.report.reportType = '0'
    }
    this.report.mergeSame = this.report.mergeSame ? JSON.parse(this.report.mergeSame) : []
    // 高级筛选的列
    this.report.advancedFilterColumns = typeof (this.report.advancedFilterColumns) === 'string' ? JSON.parse(this.report.advancedFilterColumns) : this.report.advancedFilterColumns

    this.report.filters && this.report.filters.forEach(n => {
      n.dataSource = JSON.parse(n.dataSource)
      n.template = JSON.parse(n.template)
    })
    // 关联的子表中的关联的主表的字段信息是表达式,需要通过表达式查到到报表列id
    this.report.children && this.report.children.forEach(child => {
      if (child.referenceReportColumnId) {
        child.referenceReportColumnId = this.report.columns.find(n => n.expressionText === child.referenceReportColumnId).id
      }
    })
    if (this.report.columnEdit) {
      await this.$axios.get(`/form-api/defines/${this.report.editColumnForm}`).then(res => {
        this.formDefinition = res.data
      })
    }
    if (this.report.jsPath && this.report.jsFunctionsName) {
      this.loadScript(this.report.jsPath, this.id)
    }
    this.report.maxTotal = Number(this.report.maxTotal)
    this.report.clickColumn = typeof (this.report.clickColumn) === 'string' ? JSON.parse(this.report.clickColumn) : this.report.clickColumn
    this.initCodeService()
    this.$emit('reportLoaded')
  },
  beforeDestroy () {
    // 需要删除加载进来的scrip标签
    let script = document.getElementById(this.report.jsPath)
    script && document.body.removeChild(script)
  },
  destroyed () {
    this.eventBus.$emit('report.onDestory')
  },
  methods: {
    // 给当前的redcatApp对象绑定
    bindApi (redcatApp) {
      redcatApp.$el = this
      redcatApp.$UUID = UUID
    },
    getRedcatApp () {
      return this.redcatApp
    },
    async loadReport (reportId) {
      // 加载报表信息
      return (await this.$axios.get(`/report-api/report/definition/${reportId}?type=run`)).data
    },
    goBack () {
      this.$router.go(-1)
    },
    goSearch () {
      if (this.report.id && this.report.groupReportData && this.report.groupReportData.length > 1) {
        this.$refs.reportTabs.goSearch(this.formRuntimeDialog.title)
      } else {
        this.$refs.report.goSearch(this.formRuntimeDialog.title)
      }
    },
    popUpSearch () {
      this.$refs.report.popUpSearch()
    },
    initCodeService () {
      let publicDialog = this.publicDialog
      const reportService = {
        search: () => {
          this.$refs.report.$refs.filter.search()
        },
        openPublicDialog: (params) => {
          _.assign(publicDialog, params)
        }
      }
      const codeService = new CodeService({eventBus: this.eventBus, report: this.report, reportService, el: this})
      codeService.load()

      this.eventBus.$emit('report.onLoad', this.report)
    },
    closeReportDialog () {
      this.$emit('closeDialog')
    },
    loadScript (src, id) {
      let exts = document.createElement('script')
      exts.src = `${sessionStorage.getItem('ossDownloadUrl')}/${src}`
      exts.id = src
      document.body.appendChild(exts)
      exts.onload = () => {
        let redcatApp = window.redcatApp[id]
        if (redcatApp) {
          this.redcatApp = redcatApp
          // 调用脚本的load方法加载定制方法
          // 注意：因为使用call改变了当前this指向，所以在load方法中不能调用执行脚本中的其他方法
          this.redcatApp['load'] && this.redcatApp['load'].call(this, this)
          this.bindApi(this.redcatApp)
        }
      }
    }
  }
}
</script>
<style lang="scss">
.report-runtime {
  height: 100%;
  border:none;
  background: #fff;
  position: relative;
  .group-tabs {
    height: 100%;
    .el-tabs__content {
      height: calc(100% - 23px);
      .el-tab-pane {
        height: 100%;
      }
    }
  }

  .report-name-panel h3 {
    background-color: #F5F5F5;
    padding: 10px 15px;
    font-weight: normal;
    text-align: center;

    .back {
      cursor: pointer;
      float: right;
    }
  }

  >section.report-component-container {
    height: 100%;
  }
  &.rc-report-width{
    min-width: auto;
  }
}
.report-runtime.custom-page-list {
  background-color: #fafcfe;
}
.report-runtime {
  .report-component-container {
    .el-main {
      & > .report-container {
        padding-top: 4px;
      }
    }
  }
}
.report-design-preview {
  padding-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/report/runtime/report-runtime.vue